import { render } from "./TrashIcon.vue?vue&type=template&id=475faeb8"
import script from "./TrashIcon.vue?vue&type=script&lang=js"
export * from "./TrashIcon.vue?vue&type=script&lang=js"
script.render = render

export default script